export const EV_CALCULATION_CHARGING_PER_KILOMETER = 'ev-calculation/api/vehicle/charging';
